import {ONDEMAND_STATUSES} from '@/reference/ondemand';

export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const APPOINTMENT_DETAIL_TYPE_PROP = 'appointmentType';

export const APPOINTMENT_TYPES = {
  NOW: 'NOW',
  FUTURE: 'FUTURE',
  DENIED: 'DENIED',
  PENDING: 'PENDING',
  NEW_REQUEST: 'NEW_REQUEST',
};

export const CancelStatuses = {
  cancelled: 'cancelled',
  autocancelled: 'autocancelled',
};

export const AppointmentStatusNewRequest = {
  ...CancelStatuses,
  reject: 'reject',
  Accept: 'Accept',
  verify: 'verify', //Never seen this one in responses, however I will be including this because I saw it in code
  Pending: 'Pending',
  payment: 'payment',
};

export const AppointmentStatusWithToken = {
  ...CancelStatuses,
  NoShow: 'NoShow',
  Queued: 'Queued',
  Skip: 'Skip',
  Complete: 'Complete',
  Cancel: 'Cancel',
  Pending: 'Pending',
  Serving: 'Serving',
  Denied: 'Denied',
  Payment: 'payment',
};

export const DeniedEventsMapper = {
  [AppointmentStatusWithToken.Denied]: APPOINTMENT_TYPES.DENIED,
  [AppointmentStatusNewRequest.reject]: APPOINTMENT_TYPES.DENIED,
  [AppointmentStatusNewRequest.autocancelled]: APPOINTMENT_TYPES.DENIED,
  [AppointmentStatusNewRequest.cancelled]: APPOINTMENT_TYPES.DENIED,
};

export const AppointmentStatusToEventTypeMapper = {
  ...DeniedEventsMapper,
  [AppointmentStatusNewRequest.payment]: APPOINTMENT_TYPES.PENDING,
  [AppointmentStatusNewRequest.Pending]: APPOINTMENT_TYPES.PENDING,
};

export const FILTER_ORDER = {
  Pending: {
    statuses: [
      ONDEMAND_STATUSES.PENDING,
      AppointmentStatusWithToken.Pending
    ],
    order: 0,
  },
  Queued: {
    statuses: [
      AppointmentStatusWithToken.Serving,
      AppointmentStatusWithToken.Queued,
      AppointmentStatusNewRequest.Accept,
      AppointmentStatusWithToken.Payment,
      ONDEMAND_STATUSES.PAYMENT,
      ONDEMAND_STATUSES.ACCEPT,
    ],
    order: 1,
  },
  Complete: {
    statuses: [
      AppointmentStatusWithToken.Complete
    ],
    order: 2,
  },
  Denied: {
    statuses: [
      AppointmentStatusNewRequest.reject,
      AppointmentStatusWithToken.Denied,
      AppointmentStatusWithToken.NoShow,
      ONDEMAND_STATUSES.REJECT,
    ],
    order: 3,
  },
  Cancelled: {
    statuses: [
      ONDEMAND_STATUSES.CANCELLED,
      ONDEMAND_STATUSES.AUTOCANCELLED,
      ONDEMAND_STATUSES.PAYMENT_AUTOCANCELLED,
      CancelStatuses.cancelled,
      CancelStatuses.autocancelled,
      AppointmentStatusWithToken.Cancel
    ],
    order: 4,
  },
  Skipped: {
    statuses: [
      AppointmentStatusWithToken.Skip,
    ],
    order: 5,
  },
};

export const CALL_RINGTONE_URL = 'https://nowserving.seriousmd.com/assets/ring.mp3';

// How long a denied consultation stays eligible for the Home priority card; past it the patient
// has generally moved on from that doctor. 48h agreed with the NS app team (chev). See sc-71802.
export const DENIED_VISIBILITY_WINDOW_HOURS = 48;
